module.exports = __webpack_public_path__ + "img/module_email.479904a4.jpg";